module.exports = __webpack_public_path__ + "img/waimai.7c078e0c.png";